export default __webpack_public_path__ + "static/media/hht1_song_09.12932cd8.png";